<template>
  <div
    v-if="userInfo"
    class="close-statement"
    :class="{
      'close-statement--android': $isAndroid,
    }"
  >
    <div class="close-statement__title">
      Kaspi Red <br />
      клубынан шығуға өтініш
    </div>
    <div class="close-statement__main">
      <div class="close-statement__main_block">
        Мен, {{ userInfo.fio }},<br />ЖСН {{ userInfo.iin }}, «Kaspi Bank»
        АҚ-тан №{{ userInfo.bankId }}
        бөліп төлеу және сатып алуға лимит шартын (бұдан әрі – Шарт) бұзуды,
        мені Kaspi Red клубынан шығаруды,
        {{ userInfo.repaymentAccountNumber }} шотты жабуды, №{{
          userInfo.cardNumber
        }}
        картаны тосқауылдауды сұраймын.
      </div>

      <div class="close-statement__main_block">
        Берешек толық өтелгеннен кейін Шарттың бұзылатынын түсінемін.
      </div>

      <div class="close-statement__main_block">
        Өз ақшамның қалдығын менің <a href="https://kaspi.kz">Kaspi.kz</a>-ке
        берген нұсқауыма сай банктік шотқа аударуды сұраймын.<br />
        Банктік шот болмаған жағдайда, Банктің кассасы арқылы беруді сұраймын.
      </div>
    </div>
    <div class="close-statement__divider"></div>
    <div class="close-statement__date">
      <div class="close-statement__date_title">Күн:</div>
      <div class="close-statement__date_value">
        {{ formattedDate }}
      </div>
    </div>
    <div class="close-statement__divider"></div>
    <CommonButton class="close-statement__btn" @click="$emit('sign')">
      Өтінішке қол қою
    </CommonButton>
  </div>
</template>

<script>
import dayjs from "dayjs";
import CommonButton from "@/components/shared/button/CommonButton";

export default {
  components: {
    CommonButton,
  },
  props: {
    userInfo: {
      type: [Object, null],
      required: true,
    },
  },
  computed: {
    formattedDate() {
      return dayjs().locale("kk").format("DD MMMM YYYY ж.");
    },
  },
};
</script>
